var map = {
	"./en/1-3/title.png": 82866,
	"./fi/1-3/title.png": 29732,
	"./in/1-3/title.png": 73422,
	"./th/1-3/title.png": 22215,
	"./tw/1-3/title.png": 93192,
	"./zh/1-3/title.png": 77201
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46424;